















import {
  computed,
  defineComponent,
  ref,
  Ref,
  toRefs
} from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import CGoogleAutocompleteInput from '~/components/shared/configurable/form/autocomplete/CGoogleAutocompleteInput.vue'
import { FullLocation, GoogleAutocompleteInputMode } from '~/models/google'
import { useClassifiedForm } from '~/compositions/form'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  components: {
    CFormError,
    CGoogleAutocompleteInput,
    FieldError
  },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)
    const selectedPostcode = ref<string | null>(null)

    const placeholder = computed(() => specs.value?.placeholder || '')

    function onValue(v: Ref<any>) {
      selectedPostcode.value = v.value
    }
    function onSuggestions(s: Ref<any>) {
      if (s.value?.length && !selectedPostcode.value) {
        selectedPostcode.value = s.value[0]
      }
    }

    const { valuesChanged, debouncedValueChanged, error } = useClassifiedForm(
      props,
      {
        onValue,
        onSuggestions
      }
    )

    function handleLocationChange(location: FullLocation) {
      const { postcode, address, geolocation } = location
      selectedPostcode.value = postcode
      valuesChanged([
        { name: 'address', value: address },
        { name: 'postcode', value: postcode },
        { name: 'geolocation', value: geolocation },
        { name: 'location', value: null }
      ])
    }

    function handleInput(text: string) {
      error.value = null
      debouncedValueChanged(name.value, text || null)
    }

    return {
      handleLocationChange,
      GoogleAutocompleteInputMode,
      placeholder,
      selectedPostcode,
      handleInput,
      error
    }
  }
})
